const firebaseConfig = {
  apiKey: "AIzaSyB-dP7Bf36j9GKXKBrgcU4ypxLnCDzJNT0",
  authDomain: "comfy-couch-a8e75.firebaseapp.com",
  projectId: "comfy-couch-a8e75",
  storageBucket: "comfy-couch-a8e75.appspot.com",
  messagingSenderId: "62467760952",
  appId: "1:62467760952:web:deddecb01b4663d87157cd"
};

export default firebaseConfig;